import { ref, onBeforeMount, onBeforeUnmount } from 'vue'
import { emitter } from '@/plugins/emitter'
import {
  addHistoryListItem,
  moveHistoryListItem,
  type HistoryColumns
} from '@/utils/format-edit/historyList'
import type { RirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'

const DEACTIVATE_SKILL_ITEM = 'deactivate-skill-item'

export function useDesignRirekishoSkills(formatData: RirekishoFormatData) {
  const activeHistoryItem = ref('')

  function ensureList() {
    if (!formatData.skills) {
      formatData.skills = []
    }
    return formatData.skills
  }

  function addSkills(index?: number | null, columns?: HistoryColumns) {
    addHistoryListItem(ensureList(), index, columns)
  }

  function deleteSkills(index: number) {
    ensureList().splice(index, 1)
  }

  function moveSkills(params: { index: number; to: string }) {
    moveHistoryListItem(ensureList(), params)
  }

  function activateHistoryItem(id: string) {
    activeHistoryItem.value = id
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  function deactivateSkillsItem() {
    activeHistoryItem.value = ''
  }

  onBeforeMount(() => {
    emitter.on(DEACTIVATE_SKILL_ITEM, deactivateSkillsItem)
  })

  onBeforeUnmount(() => {
    emitter.off(DEACTIVATE_SKILL_ITEM, deactivateSkillsItem)
  })

  return {
    activeHistoryItem,
    addSkills,
    deleteSkills,
    moveSkills,
    activateHistoryItem
  }
}
